import { Component, OnInit, Input, ChangeDetectionStrategy, EventEmitter, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LinkActions } from 'app/core/components/workflow-new/common/base-card-configuration';
import { CardConfiguration } from 'app/core/components/workflow-new/course/configurations/card-configuration';

declare var $;
@Component({
  selector: 'itpx-card-details',
  templateUrl: './card-details.component.html',
  styleUrls: ['../../common/style.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardDetailsComponent implements OnInit {
  @Input() platformClass: any;
  @Input() conf: CardConfiguration;
  // @Output() clicked: EventEmitter<any> = new EventEmitter<any>();
  private tagType: string;
  private expired: boolean;
  private linkActions = LinkActions;



  constructor(private router: Router,
    private route: ActivatedRoute) {

  }

  ngOnInit() {
    Object.assign(this, this.conf);
  }

  voucherExpired(course: any): boolean {
    let d = new Date(course.createdAt);
    let expiryDate = new Date(d.getFullYear() + 1, d.getMonth(), d.getDate());
    return expiryDate < new Date();
  }

  trackByFn(index, item) {
    return index; // or item.id
  }




}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/course/card-details/card-details.component.ts